@if (showAlert) {
  <div class='modal' id='modal_wrapper'>
    <div id='modal_block' class='popup_bg_modal'></div>
    <div id='modal_block_text' class='hidden'>Please wait <mat-progress-spinner mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner></div>
    <div id='modal_wrap' class='modal-dialog {{size}}'>
      <div class='modal-content modal-content-v2'>

        <div class='modal-header'>
          <h3 class="{{title_color}}">
            @if (title_icon) {
              <mat-icon  aria-hidden="true">{{ title_icon }}</mat-icon> &nbsp;
            }
            <label id='modal_title' class='modal-title font-18' [innerHTML]="title"></label>
          </h3>
          @if (!syncing && !disableClose) {
            <button id='modal_close' type='button' class='close' (click)="onClose()">&times;</button>
          }
        </div>

        <div id='modal_body' class='modal-body'>
          @if (loading) {
            <div>
              <mat-progress-spinner mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner> Cargando...
            </div>
          }
          @if (!loading) {
            <div [innerHTML]="body"></div>
          }
        </div>

        @if (showFooter) {
          <div id='modal_footer' class='modal-footer text-right'>
            @if (syncing) {
              <div>
                <mat-progress-spinner mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner> Espere...
              </div>
            }
            @if (!syncing) {
              <ul>
                @for (button of buttons; track button.title) {
                  <li>
                    <button class='btn {{button.btn_class}}' (click)="button.onClick()" [appBtnAutoFocus]="button.focus">
                      @if (button.icon) {
                        <mat-icon  aria-hidden="true">{{ button.icon }}</mat-icon>
                      }
                      {{button.title}}
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        }

        <div id='modal_msg' class='modal_msg_wrapper'></div>

      </div>
    </div>
  </div>
}
